<template>
    <div id="airwayDicomPanel" class="airway-mode-item"
        v-bind:style="{ color: mode.isWhite ? mode.blueColor : mode.whiteColor }">

        <div class="airway-dicom-list">
            <div id="axialAirwayDiv" class="airway-dicom-div">
                <img id="axialAirwaySpinner" class="airway-dcm-spinner" :src="'images/dark-blue-spinner.gif'" />
            </div>

            <div id="sagittalAirwayDiv" class="airway-dicom-div">
                <img id="sagittalAirwaySpinner" class="airway-dcm-spinner" :src="'images/dark-blue-spinner.gif'" />
            </div>

            <div id="coronalAirwayDiv" class="airway-dicom-div">
                <img id="coronalAirwaySpinner" class="airway-dcm-spinner" :src="'images/dark-blue-spinner.gif'" />
            </div>
        </div>

    </div>
</template>

<script>

import {
    selectSlice,
    enlargeSlice
} from "./AirwayMode.js";


export default {
    name: "AirwayDicomPanel",
    props: {
        airwaysData: {
            type: Object,
            required: true
        },
        mode: {
            type: Object,
            required: true
        },
    },
    mounted() {
        console.log("AirwayDicomPanel mounted");
    },
    methods: {
        enlargeClick: function (slice) {
            console.log("enlargeClick");
            // enlargeSlice(slice);
        },
    }
}

</script>

<style scoped>
#airwayDicomPanel {
    position: absolute;
    top: 45px;
    left: 4px;
    height: calc(100% - 100px);
    overflow: hidden;
}

.airway-dicom-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
    height: 100%;
}

.airway-dicom-item {
    height: 33%;
    aspect-ratio: 1 / 1;
}

.airway-dicom-div {
    height: 33%;
    aspect-ratio: 1 / 1;
    /* height: 100%;
    width: 100%; */
}

.airway-dcm-spinner {
    display: block;
    width: 24%;
    height: 24%;
    margin-top: 37%;
    margin-left: 38%;
}
</style>